import { Input } from 'components/Form/Input/Input';
import React from 'react';
import ReactInputMask from 'react-input-mask';

interface PhoneInputProps {
    label?: string;
    error?: boolean;
    required?: boolean;
    value: string | null;
    onBlur?: () => void;
    onChange: (value: string) => void;
}

export const PhoneInput = React.forwardRef<HTMLInputElement, PhoneInputProps>(
    (props: PhoneInputProps, ref) => {
        const inputRef = React.useRef<HTMLInputElement>(null);

        // Combine the forwarded ref with our local ref
        React.useImperativeHandle(ref, () => inputRef.current!, [inputRef]);

        const changeHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
            props.onChange(event.target.value);
        };

        return (
            <ReactInputMask
                mask="(999) 999-9999"
                value={props.value || ''}
                onBlur={props.onBlur}
                onChange={changeHandler}
            >
                {() => (
                    <Input
                        ref={inputRef}
                        label={props.label}
                        required={props.required}
                        error={props.error}
                    />
                )}
            </ReactInputMask>
        );
    }
);

PhoneInput.displayName = 'PhoneInput';
